import { render, staticRenderFns } from "./Brokers.vue?vue&type=template&id=7601abe6&scoped=true"
import script from "./Brokers.vue?vue&type=script&lang=js"
export * from "./Brokers.vue?vue&type=script&lang=js"
import style0 from "./Brokers.vue?vue&type=style&index=0&id=7601abe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7601abe6",
  null
  
)

export default component.exports